export default __webpack_public_path__ + "static/media/192.402e4b9d.png";